import React, { useState } from 'react';
import { Popover, Spin, Tag } from 'antd';
import { getOrderGenieLearningRecordBasis } from '../../services/orderXApi';
import { getMatchSourceBadge } from '../../pages/orderXV4Utils';

// Story 3.4 (FR-5): labels every Product candidate Base Match or Learned
// Match; for a Learned Match, a click fetches and shows the supporting
// Learning Record's basis (when + what was corrected) -- no existing
// Popover usage anywhere in this app to be consistent with, so this is the
// minimal new pattern introduced for this story.

const BasisContent = ({ loading, error, basis }) => {
  if (loading) return <Spin size="small" />;
  if (error) return <span className="text-muted small">Basis unavailable</span>;
  if (!basis) return null;
  const when = basis.created_at ? new Date(basis.created_at).toLocaleString() : 'Unknown time';
  return (
    <div style={{ maxWidth: 260 }}>
      <div className="text-muted small mb-1">{when}</div>
      <div>{basis.old_value} → {basis.new_value}</div>
    </div>
  );
};

const MatchSourceBadge = ({ match, className }) => {
  const [basis, setBasis] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [fetched, setFetched] = useState(false);

  const badge = getMatchSourceBadge(match);
  if (!badge) return null;

  const isLearned = match?.source === 'learned' && match?.learning_record_id;
  if (!isLearned) {
    return <Tag color={badge.color} className={className}>{badge.label}</Tag>;
  }

  const handleOpenChange = (open) => {
    // A prior failure must not permanently block retrying on a later open --
    // only a prior *success* should be cached and not re-fetched.
    if (open && !loading && (!fetched || error)) {
      setError(false);
      setLoading(true);
      getOrderGenieLearningRecordBasis(match.learning_record_id)
        .then((data) => {
          setBasis(data);
          setFetched(true);
        })
        .catch(() => {
          setError(true);
          setFetched(true);
        })
        .finally(() => setLoading(false));
    }
  };

  return (
    <Popover
      content={<BasisContent loading={loading} error={error} basis={basis} />}
      title="Learning basis"
      trigger="click"
      onOpenChange={handleOpenChange}
    >
      <Tag color={badge.color} className={className} style={{ cursor: 'pointer' }}>
        {badge.label}
      </Tag>
    </Popover>
  );
};

export default MatchSourceBadge;
